import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: 'service-request/:ssoToken',
    loadComponent: () => import('./service-request/service-request.component').then(m => m.ServiceRequestComponent)
  },
  {
    path: 'resident-request/:ssoToken',
    loadComponent: () => import('./resident-request/resident-request.component').then(m => m.ResidentRequestComponent)
  }
];
